// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Form as BForm } from "react-bootstrap";
import { Input } from "../../../_metronic/_partials/controls";
import Slider from "rc-slider";
import * as crud from "../CatalogUsers/operations";
import "rc-slider/assets/index.css";
import BootstrapTable from "react-bootstrap-table-next";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

// Validation schema
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  salary: Yup.number()
    .min(3, "Minimum 1 ")
    .max(50000, "Maximum 50000")
    .required("Field is necesssary"),
  description: Yup.string().optional()

});

export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  const [[min_age, max_age], setAges] = useState(
    client.ages_range || [(18, 60)]
  );
  const [[min_height, max_height], sethHeights] = useState(
    client.heights_range || [0, 3]
  );
  const [[min_weight, max_weight], sethWeights] = useState(
    client.weights_range || [0, 300]
  );
  const [show, toggleShow] = useState(false);
  const [genders, setGenders] = useState(client.genders || ["Male"]);
  const [additionals_users, setAU] = useState([]);
  function updateGender({ target }) {
    const { name, checked } = target;
    console.log({ name, checked });
    if (checked) {
      setGenders([name, ...genders]);
    } else {
      const filtered = genders.filter((g) => g !== name);
      setGenders(filtered);
    }
  }
  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (
    <>
      <ManualUsers
        show={show}
        toggleShow={toggleShow}
        add_users={setAU}
        initValues={client?.additionals_users}
      />
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={client}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update({
            ...client,
            ...values,

            ages_range: [min_age, max_age],
            heights_range: [min_height, max_height],
            weights_range: [min_weight, max_weight],

            additionals_users: additionals_users,
            genders,
          })
            .then(() => setSubmitting(false))
            .end((err) => {
              setSubmitting(false)
            })
        }}
      >

        {({ handleSubmit, handleChange, errors }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  {/* Last Name */}
                  <div className="col-lg-6">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Group Title"
                      label="Group Title"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-6">
                    <Field
                      name="salary"
                      type="number"
                      component={Input}
                      placeholder="Salary per hour"
                      label="Salary per hour"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-6">
                    <Field
                      name="description"
                      type="description"
                      component={Input}
                      placeholder="description"
                      label="description"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <BForm.Group controlId="formBasicCheckbox">
                      <label>Select Genders</label>
                      <BForm.Check
                        type="checkbox"
                        label="Male"
                        name="Male"
                        onChange={updateGender}
                        defaultChecked={genders.includes("Male")}
                      />
                      <BForm.Check
                        type="checkbox"
                        label="Female"
                        name="Female"
                        onChange={updateGender}
                        defaultChecked={genders.includes("Female")}
                      />
                    </BForm.Group>
                  </div>
                </div>
                <div className="form-group row p-1">
                  <div className="col-lg-4">
                    <label>
                      Age {min_age}-{max_age}
                    </label>
                    <Range
                      min={18}
                      max={60}
                      onChange={setAges}
                      defaultValue={client.ages_range || [18, 60]}
                      tipProps={{
                        placement: "bottom",
                      }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>
                      Weight {min_weight}lbs-{max_weight}lbs
                    </label>
                    <Range
                      min={0}
                      max={300}
                      onChange={sethWeights}
                      defaultValue={client.weights_range || [0, 300]}
                      tipProps={{
                        placement: "bottom",
                      }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>
                      Height {min_height}M-{max_height}M
                    </label>
                    <Range
                      min={0.0}
                      step={0.05}
                      max={3.0}
                      onChange={sethHeights}
                      defaultValue={client.heights_range || [0, 3]}
                      tipProps={{
                        placement: "bottom",
                      }}
                    />
                  </div>

                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              {client.uid && (
                <button
                  type="button"
                  onClick={() => toggleShow(!show)}
                  className="btn btn-info btn-elevate"
                >
                  Add User Manually
                </button>
              )}
              <div
                className={`d-flex justify-content-end ${!client.uid ? "w-100" : ""
                  }`}
              >
                <button
                  type="button"
                  onClick={handleClose}
                  className="btn btn-light btn-elevate mx-1"
                >
                  Cancel
                </button>

                <button
                  onClick={() => {
                    setSubmitting(true)
                    handleSubmit()
                  }}
                  disabled={isSubmitting}
                  className="btn btn-primary btn-elevate"
                >
                  {isSubmitting ?
                    <div className="d-flex align-items-center">
                      <div className="mr-2">Loading...</div>
                      <div className="spinner spinner-white mr-10"></div>
                    </div> : "Save"}
                </button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
export function ManualUsers(props) {
  const [filter, setFilter] = useState("");
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(props.initValues || []);
  useEffect(() => {
    crud.getClient().then(({ data }) => {
      setUsers(data.payload);
    });
  }, []);


  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelected([...selected, row.uid]);
    } else {
      setSelected(selected.filter((x) => x !== row.uid));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.uid);
    if (isSelect) {
      setSelected(ids);
    } else {
      setSelected([]);
    }
  };
  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    selected: selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  return (
    <Modal show={props.show} size="lg" onHide={() => props.toggleShow(false)}>
      <Modal.Header> Add User Manually</Modal.Header>
      <Modal.Body>
        <div className="col-lg-3">
          <input
            type="text"
            className="form-control"
            name="searchText"
            placeholder="Search"
            onChange={({ target }) => {
              const { value } = target;
              setFilter(value);
            }}
          // onBlur={}
          // value={values.searchText}
          // onChange={(e) => {
          //   setFieldValue("searchText", e.target.value);
          //   handleSubmit();
          // }}
          />
          <small className="form-text text-muted">
            <b>Search</b> in all fields
          </small>
        </div>
        <br />
        <div className="mt-5" style={{ overflowY: "scroll", height: "100%", maxHeight: "35vh" }}>
          <BootstrapTable
            wrapperClasses="table-responsive"
            bordered={false}
            classes="table table-head-custom table-vertical-center  "
            bootstrap4
            hover
            noDataIndication={<div className="mr-2 text-muted">No records found</div>}
            selectRow={selectRow}
            keyField="uid"
            columns={[{
              dataField: "no",
              text: "NO",
              sort: true,
              headerStyle: {
                width: "80px"
              },
              formatter: (c, r, i) => i + 1
            }, ...crud.columns.filter(
              (col) =>
                !["bank_routing", "bank_account", "genre", "status"].includes(
                  col.dataField
                )
            )]}
            data={users
              .filter((user) => user?.docheck)
              .filter((data) => {
                for (const field of ["name", "phone"]) {
                  const value = data[field].toUpperCase();
                  if (value.indexOf(filter.toUpperCase()) >= 0) {
                    return true;
                  }
                }
                return false;
              })}
          ></BootstrapTable>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {" "}
        <button
          type="button"
          onClick={() => props.toggleShow(false)}
          className="btn btn-light btn-elevate mx-1"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary btn-elevate"
          onClick={() => {
            props.add_users(selected);
            props.toggleShow(false);
          }}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
}
export function ClientEditModal(props) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        dialogClassName="p-5"
        size="lg"
      >
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Profile" : "New Profile"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Profile</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>Profile</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
